import { RestApi } from "../services/rest-api";
import { YesNo } from "../types/yes-no.type";
import { Master } from "./masters.model";

export interface ItemModel {
  id?: number;
  group?: Master;
  group_id?: number;
  item_name: string;
  item_type: string;
  pi_rate: number;
  si_rate: number;
  po_rate: number;
  so_rate?: number;
  bag: number;
  qty: number;
  amt: number;
  base_val: number;
  gst_val: number;
  dyeing_val: number;
  bharai_val: number;
  wastage_val: number;
  net_val: number;
  weight_val: number;
  meter_val: number;
  total_exp_val: number;
  per_day_val: number;
  exp_val: number;
  kadai_sippy_val: number;
  finishing_val: number;
  brk_val: number;
  stock_view: string;
  publish: YesNo;
}

export const fetchItemList = async (authInfo: any) => {
  return await RestApi<{
    data: Array<ItemModel>;
    masters: {
      groups: Array<Master>,
      types: Array<Master>,
    }
  }>('post', 'itemList', {}, authInfo.user.authorization).then(function (response) {
    return response;
  });
};

export const deleteItem = async (id: number, authInfo: any) => {
  return await RestApi<any>('post', 'deleteItem', { id }, authInfo.user.authorization).then(function (response) {
    return response;
  });
};

